$(function () {
  if (!customElements.get('marketing-activity')) {
    customElements.define(
      'marketing-activity',
      class marketingActivity extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          const marketingActivityItemDetailIcon = this.querySelectorAll('.marketing-activity__item-detail-icon');
          marketingActivityItemDetailIcon.forEach((item) => {
            item.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              if (this.isMobile()) {
                marketingActivityItemDetailIcon.forEach((icon) => {
                  const marketingActivityItem = icon.closest('.marketing-activity__item');
                  marketingActivityItem.dataset.showDetail = false;
                });
                const marketingActivityItem = item.closest('.marketing-activity__item');
                marketingActivityItem.dataset.showDetail = true;
              }
            });
          });
          document.addEventListener('click', this.closeDetail.bind(this));
        }

        closeDetail() {
          const marketingActivityItemDetailIcon = this.querySelectorAll('.marketing-activity__item-detail-icon');
          marketingActivityItemDetailIcon.forEach((item) => {
            const marketingActivityItem = item.closest('.marketing-activity__item');
            marketingActivityItem.dataset.showDetail = false;
          });
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.closeDetail.bind(this));
        }

        // 判断是否是移动端
        isMobile() {
          const userAgent = navigator.userAgent.toLowerCase();
          return /mobile|android|iphone|ipad|phone|mozilla/i.test(userAgent);
        }
      }
    );
  }
});
